'use strict';

angular.module(ModuleName).constant(
  'DROP_DOWNS', {
    TY2015: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1I'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H',
        '2I'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F'
      ]
    },
    TY2016: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F'
      ]
    },
    TY2017: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F'
      ]
    },
    TY2018: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F'
      ]
    },
    TY2019: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F'
      ]
    },
	TY2020: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K',
        '1L',
        '1M',
        '1N',
        '1O',
        '1P',
        '1Q',
        '1R',
        '1S',
        '1T',
        '1U'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G'
      ],
      PlanStartMonth: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ]
    },
  TY2021: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K',
        '1L',
        '1M',
        '1N',
        '1O',
        '1P',
        '1Q',
        '1R',
        '1S',
        '1T',
        '1U'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G'
      ],
      PlanStartMonth: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ]
    },
  TY2022: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K',
        '1L',
        '1M',
        '1N',
        '1O',
        '1P',
        '1Q',
        '1R',
        '1S',
        '1T',
        '1U'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G'
      ],
      PlanStartMonth: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ]
    },
  TY2023: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K',
        '1L',
        '1M',
        '1N',
        '1O',
        '1P',
        '1Q',
        '1R',
        '1S',
        '1T',
        '1U'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G'
      ],
      PlanStartMonth: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ]
    },
    TY2024: {
      CoverageCodes: [
        '1A',
        '1B',
        '1C',
        '1D',
        '1E',
        '1F',
        '1G',
        '1H',
        '1J',
        '1K',
        '1L',
        '1M',
        '1N',
        '1O',
        '1P',
        '1Q',
        '1R',
        '1S',
        '1T',
        '1U'
      ],
      HarborCodes: [
        '2A',
        '2B',
        '2C',
        '2D',
        '2E',
        '2F',
        '2G',
        '2H'
      ],
      originOfPolicy: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G'
      ],
      PlanStartMonth: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
      ]
    }
  }
);
